export default __webpack_public_path__ + "static/media/downloadIconNew.850d5106.svg";